import { ISelectType } from "@4uhub/lib4uhub";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ImportExportRoundedIcon from "@mui/icons-material/ImportExportRounded";
import {
  Box,
  IconButton,
  Popover,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { IDashboardSortPopoverProps } from "./models";

const translationPath = "components.panel.";

export const DashboardSortPopover = memo(
  ({ value, onChange }: IDashboardSortPopoverProps) => {
    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const options: ISelectType[] = [
      { id: "name", name: t(translationPath + "name") },
      { id: "average-asc", name: t(translationPath + "average_asc") },
      { id: "average-desc", name: t(translationPath + "average_desc") },
    ];

    return (
      <>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box
            sx={{
              p: 2,
              width: 220,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography sx={{ fontWeight: 700 }}>
              {t("components.panel.order")}
            </Typography>
            <ToggleButtonGroup
              orientation="vertical"
              value={value}
              exclusive
              onChange={onChange}
              color="primary"
            >
              {options.map((option) => (
                <ToggleButton
                  key={option.id}
                  value={option.id}
                  aria-label={option.id}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography>{option.name}</Typography>
                  {value === option.id && <CheckRoundedIcon fontSize="small" />}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </Popover>

        <Tooltip title={t("components.panel.order")}>
          <IconButton onClick={handleClick}>
            <ImportExportRoundedIcon />
          </IconButton>
        </Tooltip>
      </>
    );
  }
);
